// ───────────────────────────────────────────────────────────────────
// Error + performance monitoring (Sentry) for the employer web app.
//
// One init chokepoint, called once from main.tsx before the app boots so the
// earliest render/network errors are captured. Mirrors the analytics module:
// if no DSN is configured every Sentry call is a harmless no-op.
//
// Tracing + session replay are sampled lightly in production and fully in dev.
// ───────────────────────────────────────────────────────────────────

import * as Sentry from "@sentry/react";
import { SENTRY_DSN, MODE, IS_PROD } from "@/env";

export function initSentry(): void {
  if (!SENTRY_DSN) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: MODE,
    // Sends default PII (e.g. IP address). Keep in sync with our privacy policy.
    sendDefaultPii: true,
    // Forward console logs to Sentry's Logs feature.
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: IS_PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: IS_PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Tie captured events to the signed-in user. Pass null on logout to clear.
export function setSentryUser(id: string | null): void {
  if (!SENTRY_DSN) return;
  Sentry.setUser(id ? { id } : null);
}
